import { colors } from '@fikasio/styles';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Icon, Table } from '@fikasio/react-ui-components';
import EmptyTableRow from 'components/UI/EmptyTableRow';
import TrashIcon from 'components/UI/TrashIcon';
import { useDeleteFieldFromEntityMutation } from 'services/entities/api';
import { setPaneContent } from 'services/pane/slice';
import AddFieldButton from './AddFieldButton';

const EntityFieldsTable = ({
  entity,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [deleteField] = useDeleteFieldFromEntityMutation();

  return (
    <>
      <AddFieldButton
        onClick={() => dispatch(
          setPaneContent({
            type: 'ENTITY_FIELD',
            entityId: entity.id,
            id: 'NEW',
          })
        )}
        style={{
          float: 'right',
          marginRight: 0,
        }}
      />
      <Table>
        <thead>
          <tr>
            <th>{t('name')}</th>
            <th>{t('type')}</th>
            <th
              style={{
                width: 60,
              }}
            >
              {t('required')}
            </th>
            <th
              style={{
                width: 35,
              }}
            />
            <th
              style={{
                width: 35,
              }}
            />
          </tr>
        </thead>
        <tbody>
          {
            (!entity.fields || !entity.fields.length) && (
              <EmptyTableRow
                colSpan={5}
                message={t('noFieldsToDisplay')}
              />
            )
          }
          {
            (entity.fields || [])
              .map(field => (
                <tr key={field.id}>
                  <td>
                    {field.name}
                  </td>
                  <td>
                    {field.type}
                  </td>
                  <td>
                    {
                      field.isRequired && (
                        <Icon
                          name="check"
                          size="1x"
                          onClick={() => deleteField({
                            entityId: entity.id,
                            id: field.id,
                          })}
                          style={{
                            color: 'blue',
                            cursor: 'pointer',
                            marginLeft: 10,
                          }}
                        />
                      )
                    }
                  </td>
                  <td>
                    <Icon
                      name="edit"
                      onClick={() => dispatch(
                        setPaneContent({
                          type: 'ENTITY_FIELD',
                          entityId: entity.id,
                          id: field.id,
                        })
                      )}
                      size="1x"
                      style={{
                        color: 'blue',
                        cursor: 'pointer',
                        marginLeft: 10,
                      }}
                    />
                  </td>
                  <td>
                    <TrashIcon
                      size="1x"
                      onClick={() => deleteField({
                        entityId: entity.id,
                        id: field.id,
                      })}
                      style={{
                        color: colors.danger,
                        cursor: 'pointer',
                        marginLeft: 10,
                      }}
                    />
                  </td>
                </tr>
              ))
          }
        </tbody>
      </Table>
    </>
  );
};

export default EntityFieldsTable;
